import { BaseNavigationItemBuilder } from '@/agent/entities/navigation/BaseNavigationItemBuilder'
import { type NavAction, type NavItem, type NavItemContext, NavItemTypeEnum } from '@/common/types/navigation'
import { type IModuleContext } from '@/common/types/module'
export class MailNavigationItemBuilder extends BaseNavigationItemBuilder {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(context: IModuleContext, action: NavAction<any>) {
    super(context, action)
    this.textKey = 'assist.action.mail'
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  *buildNavigationItem(action: NavAction<any>, itemContext: NavItemContext): IterableIterator<NavItem> {
    yield {
      ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.EventModal),
      target: 'front:open-modal-common',
      payload: {
        selector: '#chooseMailboxModal',
      },
    } as NavItem
  }
}
